import { render } from "./BottomSheet.vue?vue&type=template&id=4ad1f70b&scoped=true"
import script from "./BottomSheet.vue?vue&type=script&lang=js"
export * from "./BottomSheet.vue?vue&type=script&lang=js"

import "./BottomSheet.vue?vue&type=style&index=0&id=4ad1f70b&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad1f70b"]])

export default __exports__